import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CoinsService_GetCoinsHistoryLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {useCustomerSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../ReductionsState/useReductionsStateRequestParameter';

export const COINS_HISTORY_PAGE_SIZE = 20;

export const useCoinsHistory = (
  updateNextToken: (token: string | null) => void,
  continuationToken?: string,
) => {
  const session = useCustomerSession();

  return useGrpcRequest(
    CoinsService_GetCoinsHistoryLazy,
    {
      reductionsState: useReductionsStateRequestParameter(),
      session: session!,
      continuationToken: continuationToken || null,
      elementCount: COINS_HISTORY_PAGE_SIZE,
    },
    {
      disabled: !session,
      onSuccess(data) {
        updateNextToken(data.continuationToken || null);
      },
      mockData: async args => {
        return await import('../__mocks__/getCoinsHistoryMock').then(module =>
          module.getPaginatedCoinsHistoryMock(
            COINS_HISTORY_PAGE_SIZE,
            args?.continuationToken as string,
          ),
        );
      },
    },
  );
};
